import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  openUsersModal: any;
  openRolesModal: any;
  openPermissionModal: any;
  usersRowData: any[];
  rolesRowData: any[];
  permissionRowData: any[];
  isEditUser: any;
  selectUserData: any;
  isEditRole: any;
  selectRoleData: any;
  isApproved: any;
}

const initialState: InitialState = {
  openUsersModal: false,
  openRolesModal: false,
  openPermissionModal: false,
  usersRowData: [],
  rolesRowData: [],
  permissionRowData: [],
  isEditUser: false,
  selectUserData: {},
  isEditRole: false,
  selectRoleData: {},
  isApproved: false,
};

export const usersSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setOpenUserModal: (state: any, action: PayloadAction<any>) => {
      state.openUsersModal = action.payload;
    },
    setOpenRolesModal: (state: any, action: PayloadAction<any>) => {
      state.openRolesModal = action.payload;
    },
    setOpenPermissionModal: (state: any, action: PayloadAction<any>) => {
      state.openPermissionModal = action.payload;
    },
    setUsersRowData: (state: any, action: PayloadAction<any>) => {
      state.usersRowData = action.payload;
    },
    setRolesRowData: (state: any, action: PayloadAction<any>) => {
      state.rolesRowData = action.payload;
    },
    setPermissionRowData: (state: any, action: PayloadAction<any>) => {
      state.permissionRowData = action.payload;
    },
    setIsEditUser: (state: any, action: PayloadAction<any>) => {
      state.isEditUser = action.payload;
    },
    setSelectUserData: (state: any, action: PayloadAction<any>) => {
      state.selectUserData = action.payload;
    },
    setIsEditRole: (state: any, action: PayloadAction<any>) => {
      state.isEditRole = action.payload;
    },
    setSelectRoleData: (state: any, action: PayloadAction<any>) => {
      state.selectRoleData = action.payload;
    },
    setIsApproved: (state: any, action: PayloadAction<any>) => {
      state.isApproved = action.payload;
    },
  },
});

export const {
  setOpenUserModal,
  setOpenRolesModal,
  setOpenPermissionModal,
  setUsersRowData,
  setRolesRowData,
  setPermissionRowData,
  setIsEditUser,
  setSelectUserData,
  setIsEditRole,
  setSelectRoleData,
  setIsApproved,
} = usersSlice.actions;
